import React from 'react';
import { Table, Tag } from 'antd';
import {
  COLUMN_EXTRA_LARGE,
  PAGE_SIZE_OPTIONS,
  SCROLL_Y,
} from 'constants/table';
import { checkValue, formatDate } from 'utils';
import { renderWithTooltip } from 'utils/table';
import { InputFilter } from 'components/Filters/InputFilter';
import { FilterIcon } from 'components/Filters/FilterIcon';

function ContractorsTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  filters = {},
  onRowClick,
  onChange,
  onFilter,
}) {
  const { name, bin_iin, address } = filters;

  const columns = [
    {
      width: COLUMN_EXTRA_LARGE,
      title: 'Наименование',
      dataIndex: 'nameRu',
      key: 'nameRu',
      render: (value) => renderWithTooltip(value, 60),
      filterDropdown: () => (
        <InputFilter
          value={name}
          placeholder="Поиск по наименованию"
          onFilterChange={(name) => onFilter({ name })}
        />
      ),
      filterIcon: () => <FilterIcon search isActive={name} />,
    },
    {
      title: 'БИН/ИИН',
      dataIndex: 'bin_iin',
      key: 'bin_iin',
      filterDropdown: () => (
        <InputFilter
          value={bin_iin}
          placeholder="Поиск по ИИН"
          onFilterChange={(bin_iin) => onFilter({ bin_iin })}
        />
      ),
      filterIcon: () => <FilterIcon search isActive={bin_iin} />,
    },
    {
      title: 'Адрес',
      dataIndex: 'addressRu',
      key: 'addressRu',
      render: (value) => renderWithTooltip(value),
      filterDropdown: () => (
        <InputFilter
          value={address}
          placeholder="Поиск по адресу"
          onFilterChange={(address) => onFilter({ address })}
        />
      ),
      filterIcon: () => <FilterIcon search isActive={address} />,
    },
    {
      title: 'КОГД',
      dataIndex: 'kogd',
      key: 'kogd',
      render: checkValue,
    },
    {
      title: 'Дата создания',
      dataIndex: 'created',
      key: 'created',
      render: (date) => formatDate(date),
    },
    {
      title: 'Статус',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (active) => {
        const text = active ? 'Активный' : 'Не активный';
        const color = active ? 'green' : 'red';

        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      width: COLUMN_EXTRA_LARGE,
      title: 'Клиент',
      dataIndex: 'sender_name',
      key: 'sender_name',
      render: (name) => renderWithTooltip(name, 60),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      scroll={{ y: SCROLL_Y, x: '1200px' }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onRow={(record) => {
        return {
          onDoubleClick: () => onRowClick(record),
        };
      }}
      onChange={onChange}
    />
  );
}

export { ContractorsTable };
